import { Button } from '@jouzen/ecom-components/v3/Button';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import RichText from '@/app/components/RichText';
import SimpleTwoColumnModule from '@/app/components/SimpleTwoColumnModule';

import { useSizingPageModalContext } from '../contexts/SizingPageModalProvider';

const SizingGuidesSection = () => {
  const t = useTranslations();
  const modalContext = useSizingPageModalContext();

  const onGen4SizingGuideClick = () => {
    modalContext.setOr4SizeGuideVisible(true);
  };

  const onGen3SizingGuideClick = () => {
    modalContext.setOr3SizeGuideVisible(true);
  };

  return (
    <SimpleTwoColumnModule
      data-cy="sizing-guides-section"
      heading={{
        after: null,
        content: 'sizing_gen4_sizing_guides_title',
      }}
    >
      <Typography Element="h3" variant="h4">
        {t('sizing_gen4_sizing_guides_or4_title')}
      </Typography>
      <Typography className="text-lg">
        <RichText messageKey="sizing_gen4_sizing_guides_or4_content" />
      </Typography>
      <Button
        data-cy="sizing-guides-section-gen4-cta"
        onClick={onGen4SizingGuideClick}
        variant="secondary-dark"
      >
        <RichText messageKey="sizing_gen4_sizing_guides_or4_cta" />
      </Button>
      <Typography Element="h3" variant="h4">
        {t('sizing_gen4_sizing_guides_or3_title')}
      </Typography>
      <Typography className="text-lg">
        <RichText messageKey="sizing_gen4_sizing_guides_or3_content" />
      </Typography>
      <Button
        data-cy="sizing-guides-section-gen3-cta"
        onClick={onGen3SizingGuideClick}
        variant="secondary-dark"
      >
        <RichText messageKey="sizing_gen4_sizing_guides_or3_cta" />
      </Button>
    </SimpleTwoColumnModule>
  );
};

export default SizingGuidesSection;
